import { FC } from 'react'
import { UserProtectedRoute } from 'routes'
import { OfferDetails } from 'components/Offer'

const OfferDetailsPage: FC = () => {
  return (
    <UserProtectedRoute>
      <OfferDetails />
    </UserProtectedRoute>
  )
}

export default OfferDetailsPage
